module.exports = __webpack_public_path__ + "static/media/Notask.adc1e718.png";